import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import { Button as CdpButton } from '@pearsontechnology/aero-components';

const Input = styled.input`
  font-size: 0.875rem;
  line-height: 2.5rem;
  min-width: 100%;
  padding-left: 0.75rem;
  color: rgba(0,0,0,0.6);
  border: 1px solid #D9D9DE;
  border-radius: 4px;
  background-color: #FFFFFF;
  paddingRight: 3rem;

  &:focus { box-shadow: 0 0 0 4px rgba(0,0,0,0.3); outline: 0; }

  &::-webkit-outer-spin-button, &::-webkit-inner-spin-button { -webkit-appearance: none; }
  -moz-appearance:textfield;
 `;

const MaxNumber = styled.div`
  background-color: rgba(0,0,0,0.05);
  color: rgba(0,0,0,0.7);
  font-size: 0.875rem;
  line-height: 2.5rem;
  width: 3rem;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-left: 1px solid #D9D9DE;
  text-align: center;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`;

const Label = styled.label`
  color: rgba(0,0,0,0.7);
  font-family: 'adelle-sans',system-ui,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
`;

const Wrapper = styled.div`
  position: relative;
`;

const MetaWrapper = styled.div`
  opacity: 0.6;
  font-size: 0.875em;
  margin-bottom: 1em;
  & > span { vertical-align: middle }
  & > svg { margin-right: 0.5em; }
`;

export const SubmittedText = ({ children }) => (
  <MetaWrapper>
    <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24">
      <path d="M20 3h-1V1h-2v2H1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" />
      <path fill="none" d="M0 0h24v24H0z" />
    </svg>
    {children}
  </MetaWrapper>
);

SubmittedText.propTypes = {
  children: PropTypes.node.isRequired,
};

const withLabel = (Component) => {
  const wrapped = ({ label, ...props }) => (
    <Label>
      {label}
      <Component {...props} />
    </Label>
  );
  wrapped.propTypes = {
    label: PropTypes.string,
  };

  return wrapped;
};

withLabel.propTypes = {
  Component: PropTypes.element,
};

const _MaxNumberInput = (props) => (
  <Wrapper>
    <Input type="number" {...props} />
    <MaxNumber>/{props.max}</MaxNumber>
  </Wrapper>
);

_MaxNumberInput.propTypes = {
  max: PropTypes.number,
};

export const MaxNumberInput = withLabel(_MaxNumberInput);

export const Button = styled(CdpButton)`
  width: 100%;
  margin-top: 1rem;
  overflow: visible;
  & > span { overflow: hidden; }
`;

const AnimNotification = keyframes`
  0% { opacity: 0; transform: translate3d(-50%, 0, 0) }
  30%, 70% { opacity: 1 }
  100% { opacity: 0; transform: translate3d(-50%, -10px, 0) }
`;

export const Notification = styled.div`
  animation: ${AnimNotification} 1.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  top: -100%;
  left: 50%;
  background: ${(props) => props.theme['color.greenLight']};
  color: rgba(0, 0, 0, 0.7);
  padding: 8px 15px 8px 10px;
  border-radius: 4px;
  line-height: 14px;
  font-size: 14px;
  display: flex;
  align-items: center;
  text-transform: capitalize;
  letter-spacing: normal;
  font-weight: 600;

  & > i {
    font-size: 18px;
    width: 18px;
    height: 18px;
    margin-right: 5px
  }
`;

